<template>
  <canvas ref="canvas" class="code"  />
</template>

<script setup>
import {ref,onMounted, nextTick} from 'vue'
import QrCodeWithLogo from 'qr-code-with-logo'
import Logo from '@/assets/images/logo.png'

const canvas = ref(null)

const generateCode = (url = '')=>{
  if(!url) url = window.location.href
  QrCodeWithLogo.toCanvas({
  canvas:canvas.value,
  content: url,
  width: 380,
  logo: {
    src: Logo,
    radius: 8
  }
})
}

onMounted(()=>{
  nextTick(()=>generateCode())
})

defineExpose({
  generateCode
})



</script>

<style scoped>
canvas.code {
  width: 100px !important;
  height: 100px !important
}

</style>
